import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CTA } from '@components/cta';
import { Typography } from '@components/typography';

import WorldMap from '@/components/ui/world-map';

export function WorldMapView() {
  const { t } = useTranslation();

  const worldMap = useMemo(
    () => (
      <WorldMap
        dots={[
          {
            start: {
              lat: 64.2008,
              lng: -149.4937,
            }, // Alaska (Fairbanks)
            end: {
              lat: 34.0522,
              lng: -118.2437,
            }, // Los Angeles
          },
          {
            start: { lat: 64.2008, lng: -149.4937 }, // Alaska (Fairbanks)
            end: { lat: -15.7975, lng: -47.8919 }, // Brazil (Brasília)
          },
          {
            start: { lat: -15.7975, lng: -47.8919 }, // Brazil (Brasília)
            end: { lat: 38.7223, lng: -9.1393 }, // Lisbon
          },
          {
            start: { lat: 51.5074, lng: -0.1278 }, // London
            end: { lat: 28.6139, lng: 77.209 }, // New Delhi
          },
          {
            start: { lat: 28.6139, lng: 77.209 }, // New Delhi
            end: { lat: 43.1332, lng: 131.9113 }, // Vladivostok
          },
          {
            start: { lat: 28.6139, lng: 77.209 }, // New Delhi
            end: { lat: -1.2921, lng: 36.8219 }, // Nairobi
          },
        ]}
      />
    ),
    []
  );

  return (
    <div className="relative flex items-center justify-center dark:bg-black bg-white w-full h-[50vh] lg:h-[70vh]">
      {worldMap}
      <div className="absolute w-full lg:aspect-[2/1] h-full lg:h-auto overflow-hidden">
        <div
          className="absolute w-[300%] lg:w-full aspect-[2/1] inset-0 pointer-events-none top-0"
          style={{
            background: 'linear-gradient(white 10%, white 10%, transparent 50%, white 70%)',
          }}
        ></div>
      </div>
      <div className="absolute w-full aspect-[2/1] flex flex-col justify-center items-center text-center mt-[10vh] lg:mt-[30vh] mb-[7vh] lg:mb-[15vh] px-4 lg:px-0">
        <Typography variant="titlesmall" align="center">
          {t('worldTitle')}
        </Typography>
        <Typography className="lg:px-40 mt-4 lg:mt-5 lg:mb-15" align="center">
          {t('worldDescription')}
        </Typography>

        <div className="w-full flex justify-center mt-[5vh] lg:mt-0">
          <CTA data-id="boton-16" />
        </div>
      </div>
    </div>
  );
}
